/**
 * @license
 * SPDX-License-Identifier: Apache-2.0
 */

import React from 'react';
import { createPortal } from 'react-dom';
import { useRegisterSW } from 'virtual:pwa-register/react';
import { motion, AnimatePresence } from 'motion/react';
import { RefreshCw, X } from 'lucide-react';
import { Capacitor } from '@capacitor/core';

const UpdatePromptInner = () => {
  const {
    needRefresh: [needRefresh, setNeedRefresh],
    updateServiceWorker,
  } = useRegisterSW({
    onRegistered(r) {
      r?.update();
    },
  });

  return (
    <AnimatePresence>
      {needRefresh && (
        <motion.div
          initial={{ opacity: 0, y: 50 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 50 }}
          className="fixed bottom-4 left-4 right-4 z-[9999] bg-emerald-500 text-black p-4 rounded-2xl shadow-2xl flex items-center justify-between gap-4"
        >
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 bg-black/10 rounded-xl flex items-center justify-center">
              <RefreshCw size={20} className="animate-spin-slow" />
            </div>
            <div>
              <div className="font-bold text-sm">Update Available</div>
              <div className="text-[10px] font-medium opacity-80 uppercase tracking-wider text-black">New features are ready</div>
            </div>
          </div>
          
          <div className="flex items-center gap-2">
            <button
              onClick={() => updateServiceWorker(true)}
              className="bg-black text-white px-4 py-2 rounded-xl text-xs font-bold"
            >
              Reload
            </button>
            <button
              onClick={() => setNeedRefresh(false)}
              className="p-2 hover:bg-black/5 rounded-lg"
            >
              <X size={18} />
            </button>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export const UpdatePrompt = () => {
  if (Capacitor.isNativePlatform()) {
    return null;
  }
  return createPortal(<UpdatePromptInner />, document.body);
};

